import React, { Component } from 'react';

class ModalMensajeResultado extends Component {
    constructor(props) {
        super(props);

        this.redireccion = this.redireccion.bind(this);
    }
    
    redireccion() {
        this.props.mostrarOcultarModal("modalMensajeResultado", "");

        if(this.props.redireccionarPantallaPrincipal) {
            this.props.routeToModelosContables("", null);
        }
    }

    render() {
        const {
            mensaje
        } = this.props;

        return (
            <div className='modalContainer'>
                <div className='modalDemandaOutXS'>
                    <div className='modalConfirmarSalirTexto ABMModelos__modalResultadoReemplazarCuentasContables__textoResultado'>
                        {mensaje}
                    </div>

                    <div className='modalProcesosFooterShort'>
                        <button onClick={this.redireccion} className="btn btn-cta">Aceptar</button>
                    </div>
                </div>
            </div>

        )
    }
}

export default ModalMensajeResultado;
